'use strict';
// Shared journal behavior; no analytics or external scripts in the local preview.
const range = document.querySelector('#compare-range');
const diagram = document.querySelector('#artery');
if (range && diagram) range.addEventListener('input', () => diagram.style.setProperty('--split', `${range.value}%`));
const progress = document.querySelector('.progress');
const sticky = document.querySelector('.sticky-offer');
const bridge = document.querySelector('#vida');
const offer = document.querySelector('#oferta');
function updateReading() {
  const max = document.documentElement.scrollHeight - innerHeight;
  progress.style.width = `${max > 0 ? Math.min(100, Math.max(0, scrollY / max * 100)) : 0}%`;
  const offerBox = offer.getBoundingClientRect();
  const visible = bridge.getBoundingClientRect().top < innerHeight * .35 && !(offerBox.top < innerHeight && offerBox.bottom > 0);
  sticky.classList.toggle('visible', visible);
  sticky.inert = !visible;
}
let framePending = false;
addEventListener('scroll', () => { if (!framePending) { framePending = true; requestAnimationFrame(() => { updateReading(); framePending = false; }); } }, {passive:true});
addEventListener('resize', updateReading);
addEventListener('load', updateReading);
updateReading();
document.querySelector('#print').addEventListener('click', () => window.print());
const words = document.querySelector('.article-body').innerText.trim().split(/\s+/).length;
document.querySelector('#reading-time').textContent = `${Math.ceil(words / 220)} min de lectura`;
// Preserve only campaign attribution, never arbitrary query data or credentials.
const campaign = new URLSearchParams(location.search);
document.querySelectorAll('[data-product-link]').forEach(link => {
  const destination = new URL(link.href);
  for (const [key,value] of campaign) if (/^utm_(source|medium|campaign|term|content|id)$/.test(key) || key === 'fbclid') destination.searchParams.set(key,value);
  link.href = destination.toString();
});
